import { render, staticRenderFns } from "./ReviewsFeed.vue?vue&type=template&id=502435ce&"
import script from "./ReviewsFeed.vue?vue&type=script&lang=ts&"
export * from "./ReviewsFeed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports